import { AnimatePresence, domAnimation, LazyMotion, m } from 'framer-motion';
import type { ReactNode } from 'react';

interface AnimatedModalProps {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  dataTestId?: string;
  /** 'dropdown' (default) fades/scales in place; 'bottomSheet' slides up from the bottom of the viewport. */
  variant?: 'dropdown' | 'bottomSheet';
}

const VARIANT_MOTION = {
  dropdown: {
    initial: { opacity: 0, scale: 0.95, y: -8 },
    animate: { opacity: 1, scale: 1, y: 0 },
    exit: { opacity: 0, scale: 0.95, y: -8 },
  },
  bottomSheet: {
    initial: { opacity: 0, y: '100%' },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: '100%' },
  },
};

export function AnimatedModal({ isOpen, children, className, dataTestId, variant = 'dropdown' }: AnimatedModalProps) {
  const motionProps = VARIANT_MOTION[variant];

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        {isOpen && (
          <m.div
            className={className}
            initial={motionProps.initial}
            animate={motionProps.animate}
            exit={motionProps.exit}
            transition={{ duration: 0.15, ease: 'easeOut' }}
            data-testid={dataTestId}
          >
            {children}
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotion>
  );
}
